import { AxiosInstance } from 'axios'
import { BaseListParams, PaginatedResponse } from '../base.type'
import { Catalog, CatalogCreate, CatalogUpdate } from '../categories/catalog.type'
import { Region } from './region.type'

export class RegionApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get all departments with pagination
     */
    async list(params?: BaseListParams): Promise<PaginatedResponse<Catalog>> {
        const response = await this.client.get<PaginatedResponse<Catalog>>('/regions', {
            params,
        })
        return response.data
    }

    /**
     * Get a single region by ID
     */
    async findOne(id: string): Promise<Region> {
        const response = await this.client.get<Region>(`/regions/${id}`)
        return response.data
    }

    /**
     * Create a new department
     */
    async create(payload: CatalogCreate): Promise<Catalog> {
        const response = await this.client.post<Catalog>('/regions', payload)
        return response.data
    }

    /**
     * Update a department
     */
    async update(id: string, payload: CatalogUpdate): Promise<Catalog> {
        const response = await this.client.put<Catalog>(`/regions/${id}`, payload)
        return response.data
    }

    /**
     * Delete a department
     */
    async delete(id: string): Promise<void> {
        await this.client.delete(`/regions/${id}`)
    }
}
